import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.entityBaseInfoId = ''
      this.orderType = ''
      this.orderFrom = ''
      this.payType = ''
      this.sportsProjectCode = ''
      this.merchantAccountId = ''
      this.range = []
      this.searchType = 'merchant'
    }
  }
}
export default searchFrom
